import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { WorkspaceType } from "@shared/types";
import useSharedWorkspace from "@shared/features/workspaces/useSharedWorkspace";
import { selectWorkspaceInitialized } from "@shared/slices/common.slice";
import { sharedLib } from "@shared/services/shared.service";
import {
  getRedirectConnectWhopChannel,
  getRedirectWhopCreateBot,
} from "@shared/utils/hooks/misc";

interface useInitializeWorkspaceProps {
  localStorageWorkspace?: string | null;
  allowAdminWorkspace?: boolean;
  isQuickConnectPath?: boolean;
}

const useSharedInitializeWorkspace = ({
  localStorageWorkspace,
  allowAdminWorkspace,
  isQuickConnectPath,
}: useInitializeWorkspaceProps) => {
  const dispatch = useDispatch();
  const workspaceInitialized = useSelector(selectWorkspaceInitialized);

  const { realUser, isWorkspaceValid, setWorkspaceType } = useSharedWorkspace({
    allowAdminWorkspace,
  });

  const setWorkspaceInitialized = (initialized: boolean) => {
    dispatch(
      sharedLib.slices.common.actions.setWorkspaceInitialized(initialized)
    );
  };

  useEffect(() => {
    if (!realUser) {
      setWorkspaceInitialized(false);
    }
  }, [realUser]);

  const getDefaultWorkspace = () => {
    if (
      !realUser?.has_clients_connected &&
      !realUser?.is_onboarding &&
      !getRedirectWhopCreateBot(realUser)
    )
      return WorkspaceType.DEMO;
    return WorkspaceType.USER;
  };

  useEffect(() => {
    if (!realUser || workspaceInitialized) return;
    let workspaceType = getDefaultWorkspace();
    if (getRedirectConnectWhopChannel(realUser)) {
      workspaceType = WorkspaceType.ADMIN;
    } else if (isQuickConnectPath || realUser.is_sub_user) {
      workspaceType = WorkspaceType.USER;
    } else if (isWorkspaceValid(localStorageWorkspace as WorkspaceType)) {
      workspaceType = localStorageWorkspace as WorkspaceType;
    }
    setWorkspaceType(workspaceType);
    setWorkspaceInitialized(true);
  }, [realUser, workspaceInitialized]);
};

export default useSharedInitializeWorkspace;
